export{useProductRecommendation}from"./hooks/use-product-recommendation.js";
//# sourceMappingURL=index.js.map
